import { FunctionField, useRecordContext } from "react-admin";
import { UserRecord } from "../resources/users/types";
import { userName } from "../resources/users/userName";

export const UserName = () => {
	const user = useRecordContext<UserRecord>();
	if (!user) return null;
	return <FunctionField label="Name" render={userName} />;
};
